module.exports = __webpack_public_path__ + "static/img/logo3.52b20377.png";